import { addDoc, collection, deleteDoc, doc, getDoc, getDocs, updateDoc } from "firebase/firestore";
import { Category, FireStoreCategory } from "../model/CategoryModel";
import { db } from "../firebaseConfig";

export const CategoryGateway = {
  GetCategories: async (): Promise<FireStoreCategory[]> => {
    const ref = collection(db, "categories");
    const snapShot = await getDocs(ref);
    return snapShot.docs.map(doc => ({ id: doc.id, category: doc.data() } as FireStoreCategory));
  },
  GetCategory: async (categoryId: string) => {
    const ref = doc(db, "categories", categoryId);
    var docSnap = await getDoc(ref);

    if (docSnap.exists()) {
      return docSnap.data() as Category;
    }

    return null;
  },
  AddCategory: async (category: Category) => {
    const docRef = await addDoc(collection(db, 'categories'), { ...category });
    return docRef.id;
  },
  UpdateCategory: async (categoryId: string, category: Category) => {
    return updateDoc(doc(db, 'categories', categoryId), { ...category });
  },
  DeleteCategory: async (categoryId: string) => {
    return deleteDoc(doc(db, 'categories', categoryId));
  }
};